export const ADD_WAYBILL_REQUEST = "VEHICLES/ADD_WAYBILL_REQUEST";
export const ADD_WAYBILL_SUCCESS = "VEHICLES/ADD_WAYBILL_SUCCESS";
export const ADD_WAYBILL_FAILURE = "VEHICLES/ADD_WAYBILL_FAILURE";

export const GET_LIST_REQUEST = "VEHICLES/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "VEHICLES/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "VEHICLES/GET_LIST_FAILURE";